import { Component, Injector } from '@angular/core';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { FormLoading } from '../../forms/base-form/base-form.component';
import { CloudService } from 'src/app/services/cloud.service';

@Component({
  selector: 'app-cloud-configuration-modal',
  templateUrl: './cloud-configuration-modal.component.html',
  styleUrls: ['./cloud-configuration-modal.component.scss'],
})
export class CloudConfigurationModalComponent extends BaseModalComponent {
  constructor(injector: Injector, private cloudService: CloudService) {
    super(injector);
  }

  public async handleSubmit({ values, formLoading }: { values: any; formLoading: FormLoading }) {
    try {
      this.startLoading();
      formLoading.start();

      await this.cloudService.createOrUpdateCloud({
        configuration: values,
      });

      formLoading.stop();
      this.stopLoading();
      this.close(values);
    } catch (err) {
      formLoading.stop();
      this.stopLoading();
    }
  }
}
